angular.module('app.filters').filter('simulcastStatus', ($filter) => {
  'ngInject';
  return (status) => {
    switch (status) {
      case null:
        return 'N/A';
      default:
        return $filter('unslugify')(status);
    }
  };
});



// WEBPACK FOOTER //
// ./app/filters/simulcast-status.js